const useSuggestedEditsFeatureFlag = () =>
  import.meta.env.VITE_ENABLE_SUGGESTED_EDITS_UI !== "false";

export default useSuggestedEditsFeatureFlag;
